import { isValidDateObject } from "./format-date";

const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24; // Milli/sec, sec/min, min/hr, hr/day
export const SECONDS_PER_DAY = 60 * 60 * 24;

/**
 * Format an ISO timestamp string as local time (e.g. "7:48pm").
 * Uses the browser's local timezone.
 */
export function localTimeFromTimestamp(isoTimestamp: string): string {
  const date = new Date(isoTimestamp);
  if (!isValidDateObject(date)) {
    return "";
  }
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

export const daysUntil = (futureDate: string | Date): number => {
  let futureDateMS;
  const today = new Date();
  today.setUTCHours(0);
  today.setUTCMinutes(0);
  today.setUTCSeconds(0);
  today.setUTCMilliseconds(0);

  if (typeof futureDate == "string") {
    futureDateMS = Date.parse(futureDate);
  } else {
    futureDateMS = futureDate.getTime();
  }

  if (futureDateMS > today) {
    return Math.floor((futureDateMS - today.getTime()) / MILLISECONDS_PER_DAY);
  }

  return 0;
};

export function addDays(timeMillis: number, numberOfDays: number): number {
  return timeMillis + MILLISECONDS_PER_DAY * numberOfDays;
}

export function daysAgo(date: Date): number {
  const now = new Date();
  if (!isValidDateObject(date) || date.getTime() > now.getTime()) {
    return 0;
  }
  const diffMillis = now.getTime() - date.getTime();
  return diffMillis / MILLISECONDS_PER_DAY;
}

export function secondsAgo(date: Date): number {
  const now = new Date();
  if (!isValidDateObject(date) || date.getTime() > now.getTime()) {
    return 0;
  }
  const diffMillis = now.getTime() - date.getTime();
  return diffMillis / MILLISECONDS_PER_SECOND;
}
